// ─────────────────────────────────────────────────────────────
//  Configurare API portal — punctul de legătură cu LeaseinDAC.
// ─────────────────────────────────────────────────────────────

// URL-ul backend-ului (LeaseinDAC pe Render).
// Schimbă-l dacă muți LeaseinDAC pe alt domeniu (ex. https://api.leasein.ro).
export const API_BASE = "https://leaseindac.onrender.com/api/portal";

// Cheia sub care ținem token-ul în sessionStorage.
const TOKEN_KEY = "leasein_portal_token";

export function getToken() {
  try { return sessionStorage.getItem(TOKEN_KEY); } catch { return null; }
}
export function setToken(t) {
  try { sessionStorage.setItem(TOKEN_KEY, t); } catch {}
}
export function clearToken() {
  try { sessionStorage.removeItem(TOKEN_KEY); } catch {}
}

// Helper care apelează API-ul, atașând automat token-ul.
export async function apiFetch(path, options = {}) {
  const token = getToken();
  const headers = { "Content-Type": "application/json", ...(options.headers || {}) };
  if (token) headers["Authorization"] = `Bearer ${token}`;

  const res = await fetch(`${API_BASE}${path}`, { ...options, headers });
  let data = null;
  try { data = await res.json(); } catch { data = null; }
  if (!res.ok) {
    const msg = (data && data.message) || `Eroare ${res.status}`;
    const err = new Error(msg);
    err.status = res.status;
    throw err;
  }
  return data;
}

// Descarcă un fișier (PDF factură) atașând token-ul. Întoarce un Blob.
// Necesar fiindcă un simplu <a href> nu poate trimite header Authorization.
export async function apiDownload(path) {
  const token = getToken();
  const headers = {};
  if (token) headers["Authorization"] = `Bearer ${token}`;
  const res = await fetch(`${API_BASE}${path}`, { headers });
  if (!res.ok) {
    let msg = `Eroare ${res.status}`;
    try { const d = await res.json(); if (d && d.message) msg = d.message; } catch {}
    const err = new Error(msg);
    err.status = res.status;
    throw err;
  }
  return await res.blob();
}

// Transformă calea pozei dintr-un răspuns API în URL absolut.
// Pozele Wikimedia vin deja cu http(s); cele urcate vin ca '/api/portal/...'
// și trebuie prefixate cu domeniul backend-ului.
export function urlPoza(poza) {
  if (!poza) return null;
  if (poza.startsWith("http")) return poza;
  const radacina = API_BASE.replace(/\/api\/portal\/?$/, "");
  return `${radacina}${poza}`;
}
